module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_b_positivo-6b7faa96ecfc67473dfdf10f3dd4776c.svg";